import React from 'react'
import styled from 'styled-components'
import { Flex, useModal, Skeleton } from '@polysky-libs/uikit'
import BigNumber from 'bignumber.js'
import { FontSize } from 'constants/Theme'
import { Token } from 'config/constants/types'
import { useTranslation } from 'contexts/Localization'
import { getFullDisplayBalance, getBalanceNumber, formatNumber } from 'utils/formatBalance'
import Balance from 'components/Balance'
import CollectModal from '../Modals/CollectModal'

interface HarvestActionsProps {
  earnings: BigNumber
  earningToken: Token
  sousId: number
  earningTokenPrice: number
  isBnbPool: boolean
  isLoading?: boolean
}

const HarvestActions: React.FC<HarvestActionsProps> = ({
  earnings,
  earningToken,
  sousId,
  isBnbPool,
  earningTokenPrice,
  isLoading = false,
}) => {
  const { t } = useTranslation()
  const earningTokenBalance = getBalanceNumber(earnings, earningToken.decimals)
  const formattedBalance = formatNumber(earningTokenBalance, 3, 3)

  const earningTokenDollarBalance = getBalanceNumber(earnings.multipliedBy(earningTokenPrice), earningToken.decimals)

  const fullBalance = getFullDisplayBalance(earnings, earningToken.decimals)
  const hasEarnings = earnings.toNumber() > 0
  const isCompoundPool = false

  const [onPresentCollect] = useModal(
    <CollectModal
      formattedBalance={formattedBalance}
      fullBalance={fullBalance}
      earningToken={earningToken}
      earningsDollarValue={earningTokenDollarBalance}
      sousId={sousId}
      isBnbPool={isBnbPool}
      isCompoundPool={isCompoundPool}
    />,
  )

  return (
    <Flex justifyContent="space-between" alignItems="center" mb="16px">
      <Flex flexDirection="column">
        {isLoading ? (
          <Skeleton width="80px" height="48px" />
        ) : (
          <>
            {hasEarnings ? (
              <>
                <Balance bold fontSize="20px" decimals={5} value={earningTokenBalance} />
                {earningTokenPrice > 0 && (
                  <Balance
                    display="inline"
                    fontSize="12px"
                    color="textSubtle"
                    decimals={2}
                    prefix="~"
                    value={earningTokenDollarBalance}
                    unit=" USD"
                  />
                )}
              </>
            ) : (
              <>
                <Heading color="textDisabled">0</Heading>
                <Text>
                  0 USD
                </Text>
              </>
            )}
          </>
        )}
      </Flex>
      <Btn disabled={!hasEarnings} onClick={onPresentCollect}>
        {isCompoundPool ? t('Harvest') : t('Harvest')}
      </Btn>
    </Flex>
  )
}

export default HarvestActions;

const Btn = styled.button`
color: white;
padding: 0.7rem 1.5rem;
border: none;
border-radius: 30px;
background-color: ${(props) => props.theme.theme.PRIMARY_BUTTON_COLOR_BLUE};
transition: background-color 0.5s ease-in-out;
cursor: pointer;

&:disabled{
  cursor: not-allowed;
}
`
const Text = styled.p`
  color: ${(props) => props.theme.theme.PRIMARY_BACKGROUND_COLOR};
  font-size: ${FontSize.mobil}rem;


    @media(min-width: 768px){
      font-size: ${FontSize.tab}rem;
    }
`


const Heading = styled.h2`
color: ${(props) => props.theme.theme.PRIMARY_BACKGROUND_COLOR};
  font-size: ${FontSize.mobil}rem;


    @media(min-width: 768px){
      font-size: ${FontSize.tab}rem;
    }
`